import React, { useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import { handleUserLevelAccessPermissions, changeDateFormat } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { iipMiningReport } from '../../../../Custom/IIPReport/Report/ReportExcel';



const IIPMiningReport = () => {

  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const [isDivision, setIsDivision] = useState(false);
  const [years, setYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [reportRows, setReportRows] = useState([]);
  const [reportMonths, setReportMonths] = useState([]);
  const [buttonAccess, setButtonAccess] = useState(false);
  const storedLanguage = localStorage.getItem('language');
  const navigate = useNavigate();
  const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const MONTH_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const parseNumeric = (val) => {
    if (val === null || val === undefined || val === '') return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  };

  const getVariationFromCurrentIndex = (currentCell, referenceCell) => {
    const currentIndex = parseNumeric(currentCell?.['Index(I)']);
    const referenceIndex = parseNumeric(referenceCell?.['Index(I)']);
    if (currentIndex === null || referenceIndex === null) return '';
    if (referenceIndex === 0) {
      return currentIndex === 0 ? '0.00%' : '100.00%';
    }
    const variation = ((currentIndex - referenceIndex) / referenceIndex) * 100;
    return `${variation.toFixed(2)}%`;
  };

  const getVariationMeta = (currentCell, referenceCell) => {
    const currentIndex = parseNumeric(currentCell?.['Index(I)']);
    const referenceIndex = parseNumeric(referenceCell?.['Index(I)']);
    if (currentIndex === null || referenceIndex === null) return { text: '', value: null };

    let variation = 0;
    if (referenceIndex === 0) {
      variation = currentIndex === 0 ? 0 : 100;
    } else {
      variation = ((currentIndex - referenceIndex) / referenceIndex) * 100;
    }

    return {
      text: `${variation.toFixed(2)}%`,
      value: variation,
    };
  };


  useEffect(() => {

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)
    if(level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
      setIsDivision(true);
     }

    const startYear = 2014;
    const endYear = new Date().getFullYear();
    const yearsArray = [];
    for (let y = endYear; y >= startYear; y--) yearsArray.push(y);
    setYears(yearsArray);
}, []);

  const FUTURE_MONTH_YEAR_MSG = 'Please select a valid month and year';

  const isFutureMonthYear = (monthIndex, yearVal) => {
    if (monthIndex === '' || monthIndex === null || monthIndex === undefined || yearVal === '' || yearVal === null || yearVal === undefined) {
      return false;
    }
    const y = Number(yearVal);
    const m = Number(monthIndex);
    if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
    const now = new Date();
    const cy = now.getFullYear();
    const cm = now.getMonth();
    if (y > cy) return true;
    if (y < cy) return false;
    return m > cm;
  };

  const handleMonthChange = (e) => {
    const raw = e.target.value;
    const newMonth = raw === '' ? '' : Number(raw);
    if (newMonth !== '' && selectedYear !== '' && isFutureMonthYear(newMonth, selectedYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedMonth(newMonth);
  };

  const handleYearChange = (e) => {
    const raw = e.target.value;
    const newYear = raw === '' ? '' : Number(raw);
    if (selectedMonth !== '' && newYear !== '' && isFutureMonthYear(selectedMonth, newYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedYear(newYear);
  };


//handle excel sheet ***************
  const handleGenerateExcel = () => {
    if (selectedMonth === '' || selectedYear === '') {
      toast.error('Please select month and year', messages.COLOR_RED);
      return;
    }
    if (isFutureMonthYear(selectedMonth, selectedYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
  
    showLoading(true);
    const month = MONTH_SHORT[Number(selectedMonth)];
    const year = String(selectedYear);
    // Payload like Top5IndexReport: month + year
    const payload = { month, year };
    axios
      .post(`${API_URL}api/iipReports/HQReports/IIPminingReport`, payload, config)
      .then(async (response) => {
        const respData = response.data?.data || {};

        const groups = respData.GroupCodes || [];
        const months = respData.monthArray || [];
        const apiPayload = respData.payload || { month, year, months };

        if (groups.length && months.length) {
          setReportRows(groups);
          setReportMonths(months);
          await downloadExcelReport(groups, apiPayload, months);
        } else {
          setReportRows([]);
          setReportMonths([]);
          toast.info('No data found for the selected period.', messages.COLOR_RED);
        }

        showLoading(false);
      })
      .catch((error) => {
        console.error('API Error:', error);
        showLoading(false);
      });
  };




  const getMappedData = (item, year) => {
    const result = [];
    const currentCell = item[year[0]] || {};
    for (let i = 0; i < year.length; i++) {
      const cell = item[year[i]] || {};
      const isSector = item['Industry and Item'] === 'MINING SECTOR';
      if (i === 0) {
        // Selected month: no variation column
        result.push(
          isSector ? '' : (cell['B.P.2011-12(Qty)'] ?? ''),
          isSector ? '' : (cell['C.P.(Qty)'] ?? ''),
          cell['Index(I)'] ?? '',
          cell['Index* Wt (IW)'] ?? ''
        );
      } else {
        // Previous month / previous year: Variation % based on current month Index(I)
        result.push(
          isSector ? '' : (cell['B.P.2011-12(Qty)'] ?? ''),
          isSector ? '' : (cell['C.P.(Qty)'] ?? ''),
          cell['Index(I)'] ?? '',
          cell['Index* Wt (IW)'] ?? '',
          getVariationFromCurrentIndex(currentCell, cell)
        );
      }
    }
    return result;
  };

function capitalizeFirstChar(text) {
  if (!text) return ''; // Return empty string for falsy values
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

// local helper: 0-based column index -> Excel letter
function getColumnLetterLocal(colIndex) {
  let s = '';
  let n = colIndex + 1;
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

/** Build one report block for Excel */
function buildExcelBlock(generalMiningReportData, year) {
  // Selected month: 4 cols; previous month & previous year: 5 cols (includes Variation %)
  const modifiedArray = year.flatMap((item, idx) => (idx === 0 ? [item, '', '', ''] : [item, '', '', '', '']));
  const yearColumn = ['Industry and Item ( with code)', 'Weight', 'Units', ...modifiedArray];
  const col = [];
  for (let i = 0; i < year.length; i++) {
    if (i === 0) {
      col.push('B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)');
    } else {
      col.push('B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)', 'Variation %');
    }
  }
  const excelRowData = generalMiningReportData.map(item => [
    item['Industry and Item'],
    item.Weight,
    item.Units,
    ...getMappedData(item, year)
  ]);
  return {
    yearColumn,
    headerEnglishColumns: ['', '', '', ...col],
    excelRowData,
    mergeRow: year.length,
    monthGroupSizes: year.map((_, idx) => (idx === 0 ? 4 : 5)),
  };
}

const downloadExcelReport = async (generalMiningReportData, payload, year) => {
  const block = buildExcelBlock(generalMiningReportData, year);
  let heading_Year = year[0];
  const headingMonthYear = payload?.month && payload?.year ? `${payload.month} ${payload.year}` : '';
  if (headingMonthYear) heading_Year = headingMonthYear;
  const totalCols = Array.isArray(block.yearColumn) ? block.yearColumn.length : 12;
  const lastColLetter = getColumnLetterLocal(Math.max(1, totalCols) - 1);
  const excelObjectData = {
    reportName: 'MINING SECTOR',
    mergeRow: year.length,
    fileName: `MiningReport(${heading_Year || 'Report'})`,
    fileType: 'xls',
    sheetName: `MINING SECTOR`,
    firstRowMergeCells: `A1:${lastColLetter}1`,
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: `A2:${lastColLetter}2`,
    secondRowText: `ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH`,
    thirdRowMergeCells: `A3:${lastColLetter}3`,
    thirdRowText: `COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P  (Base Year 2011-12)`,
    fourthRowMergeCells: `A4:${lastColLetter}4`,
    fourthRowText: `MINING SECTOR  (${heading_Year})`,
    fromDate: heading_Year,
    toDate: heading_Year,
    yearColumn: block.yearColumn,
    headerEnglishColumns: block.headerEnglishColumns,
    excelRowData: block.excelRowData,
    monthGroupSizes: block.monthGroupSizes,
  };
  await iipMiningReport(excelObjectData);
};

  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? titlesData.hi.MiningSectorReport : titlesData.en.MiningSectorReport }} />
             </h4>
              <div className="row align-items-center">
                {isDivision && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
                )}

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Month</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedMonth}
                    onChange={handleMonthChange}
                  >
                    <option value="">Select month</option>
                    {MONTH_NAMES.map((name, index) => (
                      <option key={index} value={index}>{name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Year</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedYear}
                    onChange={handleYearChange}
                  >
                    <option value="">Select year</option>
                    {years.length > 0 ? years.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    )) : (
                      <option value={selectedYear}>{selectedYear}</option>
                    )}
                  </select>
                </div>


                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Single table (same as Excel) */}
        {reportRows.length > 0 && reportMonths.length > 0 && (
          <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Industry and Item</th>
                      <th>Weight</th>
                      <th>Units</th>
                      {reportMonths.map((m, mi) => (
                        <th key={m} colSpan={mi === 0 ? 4 : 5} className="text-center align-middle">{m}</th>
                      ))}
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      {reportMonths.map((m, mi) => (
                        <React.Fragment key={`${m}-sub`}>
                          <th>B.P.(Qty)</th>
                          <th>C.P.(Qty)</th>
                          <th>Index(I)</th>
                          <th>Index*Wt(IW)</th>
                          {mi !== 0 && (
                            <th>Variation %</th>
                          )}
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {reportRows.map((row, idx) => (
                      <tr key={`${row['Industry and Item']}-${idx}`}>
                        <td>{row['Industry and Item']}</td>
                        <td>{row.Weight}</td>
                        <td>{row.Units}</td>
                        {reportMonths.flatMap((m, mi) => {
                          const cell = row[m] || {};
                          const currentCell = row[reportMonths[0]] || {};
                          const isSector = row['Industry and Item'] === 'MINING SECTOR';
                          const baseCells = ([
                            <td key={`${idx}-${m}-bp`}>{isSector ? '' : (cell['B.P.2011-12(Qty)'] ?? '')}</td>,
                            <td key={`${idx}-${m}-cp`}>{isSector ? '' : (cell['C.P.(Qty)'] ?? '')}</td>,
                            <td key={`${idx}-${m}-i`}>{cell['Index(I)'] ?? ''}</td>,
                            <td key={`${idx}-${m}-iw`}>{cell['Index* Wt (IW)'] ?? ''}</td>,
                          ]);
                          if (mi !== 0) {
                            const varMeta = getVariationMeta(currentCell, cell);
                            const v = varMeta.value;
                            const eps = 1e-9;
                            const isZero = v !== null && Math.abs(v) < eps;
                            const arrow = isZero ? '' : (v > 0 ? '▲ ' : '▼ ');
                            const color =
                              v === null ? '' : isZero ? 'blue' : (v > 0 ? 'green' : 'red');
                            baseCells.push(
                              <td
                                key={`${idx}-${m}-var`}
                                style={{ color, fontWeight: v === null ? 'normal' : 600 }}
                              >
                                {varMeta.text ? `${arrow}${varMeta.text}` : ''}
                              </td>
                            );
                          }
                          return baseCells;
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default IIPMiningReport;